import { render, staticRenderFns } from "./detailsPieSource.vue?vue&type=template&id=55d36724&scoped=true&"
import script from "./detailsPieSource.vue?vue&type=script&lang=js&"
export * from "./detailsPieSource.vue?vue&type=script&lang=js&"
import style0 from "./detailsPieSource.vue?vue&type=style&index=0&id=55d36724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d36724",
  null
  
)

export default component.exports